import formMainHubCustomizationAppConfiguration from './formMainHubCustomizationAppConfiguration';
import formMainHubCustomizationAssets from './formMainHubCustomizationAssets';
import formMainHubCustomizationColors from './formMainHubCustomizationColors';
import formMainHubCustomizationPersonaUI from './formMainHubCustomizationPersonaUI';


export default {
  title: 'General Customization Settings',
  attributeName: 'mainHubCustomization',
  getURL: 'mainHubs/mainHubId/customization',
  createURL: '',
  updateURL: 'mainHubs/mainHubId/customization',
  removeURL: '',
  sessionParams: ['mainHubId'],
  noArea:true,
  formConfig: [
    formMainHubCustomizationAssets,
    formMainHubCustomizationColors,
    formMainHubCustomizationPersonaUI,
    formMainHubCustomizationAppConfiguration
  ],
  autoUpdate: true,
};
